import { useRef, useEffect } from "react";

export default function SleekSingleSelect({
  placeholder = "Select...",
  options = [],
  selectedValue = null,
  onChange,
  isOpen,
  setOpen,
  innerRef,

  // NEW props
  displayFormatter, // function to control display
  width = "180px", // default smaller width
}) {
  const containerRef = useRef(null);

const getOptionValue = (opt) => opt.id;
const getOptionLabel = (opt) => opt.name;

  const selectedOption = options.find(
    (o) => getOptionValue(o) === selectedValue,
  );

  // Display logic
  const getLabel = (opt) => {
    if (!opt) return "";
    if (displayFormatter) return displayFormatter(opt);

    return getOptionLabel(opt);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside); // ✅ changed
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div
      className="jb-multiselect jb-single-select"
      ref={innerRef}
      style={{ width }}
    >
      {/* INPUT */}
      <div
        className="jb-multiselect-input"
        ref={containerRef}
        onClick={() => setOpen(!isOpen)}
      >
        <div className="jb-input-content">
          {!selectedOption ? (
            <span className="jb-placeholder">{placeholder}</span>
          ) : (
            <span className="jb-single-value">{getLabel(selectedOption)}</span>
          )}
        </div>

        {/* Arrow */}
        <span className={`jb-arrow ${isOpen ? "open" : ""}`}></span>
      </div>

      {/* DROPDOWN */}
      {isOpen && (
        <div className="jb-multiselect-dropdown">
          {options.map((opt) => {
            const id = getOptionValue(opt);
            const selected = selectedValue === id;

            return (
              <div
                key={id}
                className={`jb-multiselect-option ${
                  selected ? "selected" : ""
                }`}
                onClick={() => {
                  onChange(id, opt);
                  setOpen(false);
                }}
              >
                <span className="jb-option-label">
                  {getLabel(opt)}
                  {opt.iconUrl && (
                    <img src={opt.iconUrl} alt="" className="jb-icon" />
                  )}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
